import {
  Component,
  computed,
  inject,
  input,
  linkedSignal,
  OnInit,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResolvableModal, UiCoreModule } from '@softline/ui-core';
import { Bewe } from '../../types/bewegung';
import { MengenEingabeComponent } from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_WWS_WARENUEBERNAHME_BEWE } from '@softapps/wws/warenuebernahme';
import { WwsBewegungStore } from '../../store/bewegung.store';
import { Warenuebernahme } from '../../types/warenuebernahme';
import { MischPalettenService } from '../../services/mischpaletten-service';
import { MischPalette } from '../../types/misch-paletten';

@Component({
  selector: 'soft-position-erledigen-dialog',
  imports: [CommonModule, MengenEingabeComponent, UiCoreModule],
  templateUrl: './position-erledigen-dialog.component.html',
  styleUrls: ['./position-erledigen-dialog.component.scss'],
  providers: [MischPalettenService],
})
export class PositionErledigenDialogComponent
  extends ResolvableModal<null | 'kopf' | 'bewegung'>
  implements OnInit
{
  // public anzahlEtiketten = 0;
  public bewe = input.required<Bewe>();
  public warenuebernahme = input.required<Warenuebernahme>();

  readonly selectableMischPaletten = signal<MischPalette[] | null>(null);
  readonly selectedMischPalette = signal<MischPalette | null>(null);

  readonly mischPalettenService = inject(MischPalettenService);

  readonly anzahlEtiketten = linkedSignal(() => this.bewe()?.anzahlPalettenMin ?? 0);

  readonly rowsForSplitting = linkedSignal(() => {
    const count = this.anzahlEtiketten();
    const quantity = this.bewe()?.artikelMenge?.menge ?? 0;

    const rest = quantity % count;
    const amountPerPallet = (quantity - rest) / count;

    return Array.from(Array(count).keys()).map((index, i) => ({
      amount: i === 0 ? amountPerPallet + rest : amountPerPallet,
      index,
    }));
  });

  readonly splittingSum = computed(() =>
    this.rowsForSplitting().reduce((sum, row) => sum + row.amount, 0)
  );

  constructor(private store: Store) {
    super();
  }

  async ngOnInit() {
    const result = await this.mischPalettenService.postionErledigenMischpaletten(
      this.warenuebernahme().id
    );

    this.selectableMischPaletten.set(result.result);
  }

  // set bewegung(bewegung: Bewe) {
  //   this.anzahlEtiketten = bewegung?.anzahlPalettenMin ?? 0;
  //   this.bewe = bewegung;
  // }
  //
  // set warenuebernahme(warenuebernahme: Warenuebernahme) {
  //   this._warenuebernahme = warenuebernahme;
  // }

  async positionErledigen(anzahlEtiketten: number) {
    const result = await this.store.dispatch(
      SOFTLINE_FEATURE_WWS_WARENUEBERNAHME_BEWE,
      WwsBewegungStore.actions.positionErledigen,
      {
        warenuebernahme: this.warenuebernahme(),
        payload: {
          anzahlEtiketten: anzahlEtiketten,
          bewegung: this.bewe(),
          splittung: this.rowsForSplitting().map((row) => row.amount),
        },
      }
    );
    this.resolve(result);
  }

  async positionErledigenMischPaeltte() {
    const palette = this.selectedMischPalette()?.palette;
    if (!palette) return;

    const result = await this.store.dispatch(
      SOFTLINE_FEATURE_WWS_WARENUEBERNAHME_BEWE,
      WwsBewegungStore.actions.positionErledigenMischPalette,
      {
        warenuebernahme: this.warenuebernahme(),
        payload: {
          palette: palette,
          bewegung: this.bewe(),
        },
      }
    );
    this.resolve(result);
  }

  changePalletAmount(index: number, amount: number) {
    const array = this.rowsForSplitting();
    array.splice(index, 1, { index, amount });
    this.rowsForSplitting.set([...array]);
  }
}
